/**
 * Service for managing scheduled posts.
 */
import api from './api';

// TODO: Define these types properly based on the backend schemas
export interface Schedule {
  id: string;
  title: string;
  content?: string;
  status: string;
  post_type: string;
  scheduled_at: string;
  published_at?: string;
  platforms: string[];
  user_id: string;
  client_id?: string;
  created_at: string;
  updated_at: string;
  media_files?: string[];
}

export interface ScheduleCreate {
  title: string;
  content?: string;
  post_type: string;
  scheduled_at: string;
  platforms: string[];
  user_id: string;
  client_id?: string;
}

export interface ScheduleUpdate {
  title?: string;
  content?: string;
  scheduled_at?: string;
  platforms?: string[];
  status?: string;
}

export const scheduleService = {
  createScheduledPost: async (data: ScheduleCreate): Promise<Schedule> => {
    const response = await api.post('/schedule/', data);
    return response.data;
  },

  listScheduledPosts: async (clientId: string): Promise<Schedule[]> => {
    const response = await api.get(`/schedule/?client_id=${clientId}`);
    return response.data;
  },

  getScheduledPost: async (postId: string, clientId: string): Promise<Schedule> => {
    const response = await api.get(`/schedule/${postId}?client_id=${clientId}`);
    return response.data;
  },

  updateScheduledPost: async (postId: string, data: ScheduleUpdate, clientId: string): Promise<Schedule> => {
    // Use the posts endpoint instead of schedule endpoint
    const response = await api.put(`/posts/${postId}`, data);
    return response.data;
  },

  deleteScheduledPost: async (postId: string, clientId: string): Promise<void> => {
    await api.delete(`/schedule/${postId}?client_id=${clientId}`);
  },
};
